import React, { useEffect } from "react";
import { X } from "lucide-react";

const Lightbox = ({ open, onClose, label, children }) => {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="public-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={label || "Preview"}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="public-lightbox-panel">
        <button
          type="button"
          className="lightbox-close"
          onClick={onClose}
          aria-label="Close preview"
        >
          <X size={19} />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Lightbox;
